module.exports = __webpack_public_path__ + "img/category-brand.cd71746d.png";